import { PipeTransform } from '@angular/core';
import * as moment from 'moment';
var MomentPipe = /** @class */ (function () {
    function MomentPipe() {
    }
    MomentPipe.prototype.transform = function (value, functionName) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (!value)
            return value;
        if (!functionName)
            return value;
        if (functionName === 'parse')
            return moment(value, args[0]);
        var momentInstance = moment(value);
        return momentInstance[functionName].apply(momentInstance, args);
    };
    return MomentPipe;
}());
export { MomentPipe };
